import { Model } from "@ofqual/portal-core/core/types";

export type SocItemModel = {
    id: string;
    year: string;
    createdDate: string;
    createdByUpn: string;
    createdByDisplayName: string;
    modifiedDate: string;
    modifiedByUpn: string;
    modifiedByDisplayName: string;
    assignedToUPN: string;
    assignedToDisplayName: string;
    lastResponseByUpn: string;
    lastResponseByDisplayName: string;
    lastResponseDate: string;
    dateSubmitted: string | null;
    organisationId: number;
    status: SocStatus;
    caseTitle: string;
    referenceNumber: string;
    regulatorsToNotifyOfqual: boolean;
    regulatorsToNotifyCcea: boolean;
    regulatorsToNotifyQw: boolean;
    socActiveSubmissions: SocItemFile[];
};

export type SocItemFile = {
    
    id :string;
    socId :string;
    SubmissionType :string;
    Filename :string; 
    blobId :string;
    contentType: string;
    createdDate: string;
    createdByUpn: string;
    createdByDisplayName: string;
    modifiedDate: string;
    modifiedByUpn: string;
    modifiedByDisplayName: string;
    dateSubmitted: string | null;
    active: boolean | null;
}


export type RegulatorsToNotifyModel = {
    modifiedDate: string;
    modifiedByUpn: string;
    modifiedByDisplayName: string;
    regulatorsToNotifyOfqual: boolean;
    regulatorsToNotifyCcea: boolean;
    regulatorsToNotifyQw: boolean;
}

export enum SocStatus {
    New = 1,
    Draft = 2,
    Submitted = 3,
    InReview = 4,
    ReviewMeetingHeld = 5,
    Closed = 6,
};

export const fromApiModel = (model: Model): SocItemModel => {
    return {
        ...model,
    } as SocItemModel;
};

export const toApiModel = (item: SocItemModel): Model => {
    return {
        ...item,
    } as Model;
};